import articlePublicationStatuses from "./constants/articlePublicationStatuses";

export default function articleChannelNeedsTakedown({ article, channel }) {
	const channelData = article?.channels?.[channel?.id];

	return !!(
		!channel?.preventTakedown &&
		channelData?.publicationStatus !== articlePublicationStatuses.UNPUBLISHED &&
		(channelData?.delivery?.metadata?.sent || article?.imports)
	);
}
